import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import './offerings.scss';
import Dashboard from '../../component/Dashboard';
import { get_offering, doOfferingRes } from '../../actions/offeringActions';
import { numberWithCommasAndDollar } from '../../helper/helper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
// import SearchIcon from '@material-ui/icons/Search';
import SortIcon from '@material-ui/icons/Sort';
import CloseIcon from '@material-ui/icons/Close';
import GridTable from '@nadavshaar/react-grid-table';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
//InputAdornment

const DialogTitle = withStyles(theme => ({
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(),
      top: theme.spacing(),
      color: theme.palette.grey[500],
    },
	}))(props => {
	const { children, classes, onClose } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root}>
		<Typography variant="h6">{children}</Typography>
		{onClose ? (
			<IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
			<CloseIcon />
			</IconButton>
		) : null}
		</MuiDialogTitle>
	);
});
const DialogContent = withStyles(theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);
 
let isOfferingList = false; 
let filterData = [];

class OfferingComponent extends React.PureComponent {

	constructor(props) {
		super(props);
		isOfferingList = false; 
		filterData = [];
		this.inputElement = null;
		let columns = [
			{ id: 1, field: 'name', label: 'Name', visible: true, sortable: false, cellRenderer: this.offeringName, headerCellRenderer: this.offeringCustomHeader },
			{ id: 2, field: 'offering_type_name', label: 'Type', visible: true, sortable: false, cellRenderer: this.offeringsTemp, headerCellRenderer: this.offeringCustomHeader },
			{ id: 3, field: 'ticker_symbol', label: 'Symbol', visible: true, sortable: false, cellRenderer: this.offeringsTemp, headerCellRenderer: this.offeringCustomHeader },
			{ id: 4, field: 'trade_date', label: 'Trade Date', visible: true, sortable: false, cellRenderer: this.tradeSettlementDate, headerCellRenderer: this.offeringCustomHeader },
			{ id: 5, width: '240px', field: 'settlement_date', label: 'Settlement Date', visible: true, sortable: false, cellRenderer: this.tradeSettlementDate, headerCellRenderer: this.offeringCustomHeader },
			{ id: 6, field: 'final_price', label: 'Final Price', visible: true, sortable: false, cellRenderer: this.finalPriceTemplate, headerCellRenderer: this.offeringCustomHeader },
			{ id: 7, field: 'price_range', label: 'Price Range', visible: true, sortable: false, cellRenderer: this.priceRangeTemplate, headerCellRenderer: this.offeringCustomHeader },
			{ id: 8, width: '250px', field: 'total_requested_investors', label: 'Req Investors Count', visible: true, sortable: false, cellRenderer: this.totalRequestedInvestors, headerCellRenderer: this.offeringCustomHeader },
			{ id: 9, width: '280px', field: 'total_requested_amount', label: 'Req Investment Amount', visible: true, sortable: false, cellRenderer: this.requestedTemplate, headerCellRenderer: this.offeringCustomHeader },
			{ id: 10, field: 'status', label: 'Status', visible: true, sortable: false, cellRenderer: this.statusTemplate, headerCellRenderer: this.offeringCustomHeader },
	  	];
		this.state = {
			offeringTableView: [],
			offeringInfo: '',
			searching:'',
			cols: columns,
			offeringStatus: 'active',
			pagenum: 1,
			loadMoreAll: 'more',
			tableFilter: {
				field: null,
				order: null,
			},
			openDetailModal: false,
			offeringsLength: 0,
			lastShowOfferings: 0,
			isFetchOffering: false,
			isUiRender: false,
		}
		this.colOptions = [];
		for(let col of columns) {
			this.colOptions.push({label: col.label, value: col});
		}
	}

	componentDidMount() {
		const data = {
			status: 'active',
			pagenum: 1
		};
		isOfferingList = true;
		this.props.getOfferings(data);
	}

	static getDerivedStateFromProps(props, state) {
		if (props.offeringRes) {
			if (props.offeringRes.data && props.offeringRes.data.offering) {
				if (props.offeringRes.data.offering.message === 'Success' && isOfferingList ) {
					isOfferingList = false;
					let newData = props.offeringRes.data.offering.data;
                    if (newData) {
						newData.forEach((obj) => {
							for(var i in obj) { 
							  if(obj[i] === undefined || obj[i] === null) {
								obj[i] = '';
							  }
							}
						});
					}
                    var isOfferingLength = state.offeringsLength;
                    if(state.offeringsLength === 0){
                        isOfferingLength = newData.length
					}
					if (state.isFetchOffering) {
						return {
							offeringTableView: state.offeringTableView.concat(props.offeringRes.data.offering.data),
							lastShowOfferings: newData.length,
							offeringsLength: isOfferingLength,
							isFetchOffering: false
						};
					} else {
						return {
							offeringTableView: props.offeringRes.data.offering.data,
							lastShowOfferings: newData.length,
							offeringsLength: isOfferingLength,
						};
					}
					
				}
			}
		}
		return null;
	}
	offeringDetailModal = (offeringInfo) => {
		this.setState({
			offeringInfo:offeringInfo,
			openDetailModal: true
		})
	}
	closeOfferingDetailModal = () => {
		this.setState({
			openDetailModal: false
		})
	}
	offeringCustomHeader = ({tableManager, column, mode, ref, checked, disabled, indeterminate, onChange}) => {
		return <div>{column.label} {this.onSortFunction(column.field)}</div>
	}
	offeringsTemp = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
		if (value) {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{value}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		}
	}
	offeringName = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
		if (value) {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line green-color-with-pointer" style={{width: '90%'}} onClick={()=>this.offeringDetailModal(data)}>{value}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		}
	}
	statusTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		if (data.status === 'cancelled') {
		  return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={'Cancelled'} interactive >
					<div className="text-one-line" style={{width: '90%', color:'#FF0000'}} >Cancelled</div>
				</Tooltip>
				<Tooltip title={'Copy to clipboard'} interactive >
					<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
				</Tooltip>
			</div>;
		} else {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{value}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		}
	}

	tradeSettlementDate = ({tableManager, value, field, data, column, colIndex, rowIndex}) =>  {
		let classNames = 'rgt-cell-inner rgt-text-truncate ';
		if (data.status === 'cancelled') {
		  classNames = 'rgt-cell-inner rgt-text-truncate red_color';
		}
		return  <div className={classNames} style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
			<Tooltip title={(value !== undefined || value !== null) ? value : 'N/A'} interactive={!value} >
				<div className="text-one-line" style={{width: '90%'}} >{value === null ? 'N/A' : value}</div>
			</Tooltip>
			{
				value !== '' &&
				<Tooltip title={'Copy to clipboard'} interactive >
					<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
				</Tooltip>
			}
		</div>;
	}

	totalRequestedInvestors = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		if (data.trade_date === null && data.settlement_date === null) {
		  return <div className="rgt-cell-inner"> <span className="investorname_column_nopointer">Not Available</span> </div>;
		} else {
		  if (value && value > 0) {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line investorname_column" style={{width: '90%'}} onClick={()=> this.goDetail(data)}>{value}</div>
				</Tooltip>
				{
					value && value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		  } else {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{value}</div>
				</Tooltip>
				{
					value && value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		  }
		}
	}

	finalPriceTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {

	  if (data.trade_date === null && data.settlement_date === null) {
		return <div className="rgt-cell-inner"> Not Available </div>;
	  } else {
		if (data.final_price !== null) {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? numberWithCommasAndDollar(value) : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{numberWithCommasAndDollar(value)}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		} else {
		  return <div className="rgt-cell-inner"> Not Available </div>;
		}
	  }
	}
	
	priceRangeTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		if(data.trade_date === null && data.settlement_date === null){
		  
		  return <div className="rgt-cell-inner"> Not Available </div>
		} else {
		  if(data.offering_type_name === "IPO"){
			  let priceRange = numberWithCommasAndDollar(data.min_price) + " - " + numberWithCommasAndDollar(data.max_price);
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? priceRange : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{priceRange}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
			  
		  } else {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? numberWithCommasAndDollar(data.max_price) : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{numberWithCommasAndDollar(data.max_price)}</div>
				</Tooltip>
				{
					value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		  }
		}
		
	}

	requestedTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {

	  if(data.trade_date === null && data.settlement_date === null){
		  
		return <div className="rgt-cell-inner"> Not Available </div>
	  }else{
		if(value && value !== null){
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltip title={(value !== undefined || value !== null) ? numberWithCommasAndDollar(data.total_requested_amount) : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{numberWithCommasAndDollar(data.total_requested_amount)}</div>
				</Tooltip>
				{
					value && value !== '' &&
					<Tooltip title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltip>
				}
			</div>;
		} else {
		  return <div className="rgt-cell-inner"> N/A </div>
		}
	  }
	}

	onSortFunction(field) {
        return (<span>
            {
                ((this.state.tableFilter.field !== field)) &&
                <IconButton onClick={() => { this.doSort(field, 'asc'); }} style={{ padding: 6 }}>
                    <SortIcon style={{ fontSize: 18 }} />
                </IconButton>
            }
            {
                ((this.state.tableFilter.order === 'asc') && (this.state.tableFilter.field === field)) &&
                <IconButton className="btn-custom-sort" onClick={() => { this.doSort(field, 'desc'); }} style={{ padding: 6 }}>
                    <ArrowDropUpIcon style={{ fontSize: 18 }} />
                </IconButton>
            }
            {
                ((this.state.tableFilter.order === 'desc') && (this.state.tableFilter.field === field)) &&
                <IconButton className="btn-custom-sort" onClick={() => { this.doSort(field, 'asc'); }} style={{ padding: 6 }}>
                    <ArrowDropDownIcon style={{ fontSize: 18 }} />
                </IconButton>
            }
        </span>);
    }
	doSort(field, order) {
        if (this.state.offeringTableView) {
            // if (order === null || order === 'asc') {
            //     this.setState({
            //         isSort: 'desc',
            //         tableFilter: {
            //             field,
            //             order,
            //         },
            //     }, () => { });
            //     let payload = {
			// 		status: this.state.offeringStatus,
            //         pagenum: 1,
            //         sortby : field,
            //         sorttype: order
            //     }
            //     if (this.state.searching !== '') {
            //         payload.search_key = this.state.filterBy;
            //         payload.search_keyword = this.state.searching;
			// 	}
			// 	isOfferingList = true;
            //     this.props.getOfferings(payload);
            //     this.setState({
            //         pagenum: 1
            //     })
            // } else {
            //     this.setState({
            //         isSort: 'asc',
            //         tableFilter: {
            //             field,
            //             order,
            //         },
            //     }, () => { });
            //     let payload = {
			// 		status: this.state.offeringStatus,
            //         pagenum: 1,
            //         sortby : field,
            //         sorttype: order,
            //     }
            //     if (this.state.searching !== '') {
            //         payload.search_key = this.state.filterBy;
            //         payload.search_keyword = this.state.searching;
			// 	}
			// 	isOfferingList = true;
            //     this.props.getOfferings(payload);
            //     this.setState({
            //         pagenum: 1
            //     })
            // }

			if (order === null || order === 'asc') {
				this.setState({
					tableFilter: {
						field,
						order,
					},
				}, () => { });
				filterData = filterData.sort((a, b) => (a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0));
				this.setState({
					isUiRender: !this.state.isUiRender
				});
			} else {
				this.setState({
					tableFilter: {
						field,
						order,
					},
				}, () => { });
				filterData = filterData.sort((a, b) => (a[field] < b[field] ? 1 : a[field] > b[field] ? -1 : 0));
				this.setState({
					isUiRender: !this.state.isUiRender
				});
			}
        }
	}

	doSearchOffering = () => {
		if (this.state.searching !== '') {
			// let request = {
			// 	status: this.state.offeringStatus,
			// 	pagenum: 1,
			// 	search_key: 'name',
			// 	search_keyword: this.state.searching
			// };
			// if (this.state.tableFilter.field !== null) {
			// 	request.sortby = this.state.tableFilter.field;
			// 	request.sorttype = this.state.tableFilter.order;
			// }
			// isOfferingList = true;
			// this.props.getOfferings(request);
			// this.setState({
			// 	pagenum: 1
			// });
		}
	}

	doRefreshOrder = () => {
		let request = {
			status: this.state.offeringStatus,
			pagenum: 1,
		}
		if (this.state.tableFilter.field !== null) {
			request.sortby = this.state.tableFilter.field;
			request.sorttype = this.state.tableFilter.order;
		}
		this.setState({ pagenum: 1 })
		isOfferingList = true;
		this.props.getOfferings(request);
	}

	handleBlur = () => {
		this.setState({
			searching: ''
		}, () => {
			// this.doRefreshOrder();
		});
	}

	fetchData = () => {
		if (this.state.lastShowOfferings === this.state.offeringsLength) {
			let payload = {
				status: this.state.offeringStatus,
				pagenum: this.state.pagenum + 1
			}
			if (this.state.tableFilter.field !== null) {
				payload.sortby = this.state.tableFilter.field;
				payload.sorttype = this.state.tableFilter.order;
			}
			if (this.state.searching !== '') {
				payload.search_key = this.state.filterBy;
				payload.search_keyword = this.state.searching;
			}
			this.setState({
				isFetchOrder: true,
				pagenum: payload.pagenum,
				isFetchOffering: true
			})
			isOfferingList = true;
			this.props.getOfferings(payload, true);
		}
	}

	loadMore = () => {
		filterData = [];
		this.fetchData();
		this.setState({loadMoreAll: 'more'});
	}

	showAll = () => {
		filterData = [];
		this.setState({
				offeringTableView: [],
				loadMoreAll: 'all'
		}, () => {
			let request = {
				status: this.state.offeringStatus,
				pagenum: -1
			}
			isOfferingList = true;
			this.props.getOfferings(request, true);
			this.setState({
					uiRender: !this.state.uiRender,
					pagenum: -1,
					searching: ''
			})
		})	
	}

	onColumnShowHide = (columns) => {
		this.setState({
				cols: columns
		}, () => {
				localStorage.setItem('columnArrOrder', JSON.stringify(this.state.cols));
		})
	}
  
	export = (csvData) => {
		let csvContent = 'data:text/csv;charset=utf-8,';
		csvContent += 'Name, Type, Symbol, Trade Date, Settlement Date, Final Price, Price Range, Req Investors Count, Req Investment Amount, Status \r\n';
		csvData.forEach(function (rowArray) {
			const newRow = rowArray.name + ',' + rowArray.offering_type_name + ',' + rowArray.ticker_symbol + ',' + rowArray.trade_date + ',' + rowArray.settlement_date + ',' + rowArray.final_price + ',' + rowArray.price_range + ',' + rowArray.total_requested_investors + ',' + rowArray.total_requested_amount + ',' + rowArray.status;
			csvContent += newRow + '\r\n'; // add carriage return
		});
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', 'offering.csv');
		document.body.appendChild(link); // Required for FF
		link.click();
	}

	onColumnToggle = (event) => {
		if (event.value.length > 0) {
		  	this.setState({cols: event.value});
		}
	}

	goDetail(data){
    
		this.props.history.push({
		  pathname:`/offering-detail/${data.ext_id}`,
		  state:{
			data: data
		  }
		 });
	}
	changeOrderStatus = (e) => {
		this.setState({
			offeringStatus: e.target.value
		}, () => {
			this.setState({
				tableFilter: {
					field: null,
					order: null
				},
				searching: '',
				offeringTableView:[],
				pagenum: 1,
				checkedAll: false
			})
			let request = {
				status: this.state.offeringStatus,
				pagenum: 1
			}
			isOfferingList = true;
			this.props.getOfferings(request, true);
		})
	}
	searchOffering = (event) => {
		this.setState({
			searching: event.target.value,
		});
	}
	
	render() {
		const { offeringTableView, offeringInfo } = this.state;
		filterData = offeringTableView;
		// let filterByStatus=offeringTableView;
		// filterData = this.state.searching? filterByStatus.filter(row => {
		// 	if(row.name !== null && row.name.toLowerCase().indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// 	if(row.offering_type_name !== null && row.offering_type_name.toLowerCase().indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// 	if(row.ticker_symbol !== null && row.ticker_symbol.toLowerCase().indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// 	if(row.trade_date !== null && row.trade_date.indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// 	if(row.settlement_date !== null && row.settlement_date.indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// 	if(row.status !== null && row.status.toLowerCase().indexOf(this.state.searching.toLowerCase()) > -1){
		// 		return true
		// 	}
		// return false;}) : filterByStatus;
		
		return (
			<Dashboard title="ClickIPO Underwriter - Offerings" pageTitle="Offerings" >
				<div className="offering_content">
					<div className="offeringOrderListScroll">
				<div className="row">
					<div className="col-md-4" style={{ textAlign: 'left', marginBottom: 16, marginTop: 16,display: 'flex' }}>
						
						<div className=" offeringGlobalSearch"  style={{ marginLeft: 16, width: 260 }}>
							<FormControl style={{ width: 150 }}>
								<Select
									labelId="Offering-label"
									id="offering"
									value={this.state.offeringStatus}
									onChange={this.changeOrderStatus}
								>
									<MenuItem value={'active'}>Active</MenuItem>
									<MenuItem value={'effective'}>Effective</MenuItem>
									<MenuItem value={'closed'}>Closed</MenuItem>
									<MenuItem value={'cancelled'}>Cancelled</MenuItem>
								</Select>
							</FormControl>
						</div>
					</div>
					<div className="col-md-6" style={{ textAlign: 'right', marginBottom: 16, marginTop: 16 }}>
						{/* <div>
							<TextField 
								id="searchInput" 
								type="text" 
								placeholder="Search" 
								value={this.state.searching} 
								onChange={this.searchOffering}
								style={{width: 250}}
								InputProps={{
									endAdornment: (
										<InputAdornment position="start">
											{
												this.state.searching !== '' &&
												<Button variant="contained" color="primary" style={{ borderRadius: '0px 4px 4px 0px', minWidth: 30, top: 19, right: 0, left: 8, height: 38, background: 'transparent', color: '#333' }} onClick={() => this.handleBlur()}  ><CloseIcon className="close-icon-for-search" /></Button>
											}
											<Button variant="contained" color="primary" style={{borderRadius: '0px 4px 4px 0px', minWidth: 50, top: 19, right: 0, left: 8, height: 38}} onClick={() => this.doSearchOffering()} disabled={this.state.searching !== '' ? false : true}><SearchIcon /></Button>
										</InputAdornment>
									)
								}}
							/>
						</div> */}
					</div>
					<div className="col-md-2" style={{textAlign:'left', marginBottom:16, marginTop:16,display:'flex'}}>
						<Button variant="contained" color="primary" fullWidth={true} className="btn" onClick={() => this.export(offeringTableView)}>Download CSV</Button>
					</div>
				</div>
						{/* {filterData && filterData.length > 0 &&  */}
            	<div className="table-responsive  custom-order-table">	
						<GridTable
						 	columns={this.state.cols}
							rows={filterData}
							isPaginated={false}
							isVirtualScroll={true}
							showSearch={true}
							showRowsInformation={false}
							isHeaderSticky={true}
							onColumnsChange={this.onColumnShowHide}
						/>
						</div>
						<div className="col-md-12 mt-2">
							{
								(this.state.lastShowOfferings === this.state.offeringsLength) ?
								<Button variant="contained" color="primary" onClick={() => this.loadMore()} style={{ marginRight: 8, marginBottom: 8 }} disabled={this.state.pagenum === -1}>Load more</Button>
								:
								<Button variant="contained" color="primary" style={{ marginRight: 8, marginBottom: 8 }} disabled={true}>No more data</Button>
							}
							<Button variant="contained" color="primary" style={{ marginBottom: 8 }} onClick={() => this.showAll()}>Load all</Button>
							
						</div>
					</div>
						<Dialog
							onClose={this.closeOfferingDetailModal}
							aria-labelledby="customized-dialog-title"
							open={this.state.openDetailModal}
							maxWidth={"sm"}
							fullWidth={true}
							scroll={'paper'}
							>
							<DialogTitle onClose={this.closeOfferingDetailModal} className="offering-detail-title">{this.state.offeringInfo.name}</DialogTitle>
							<DialogContent>
								<div className="col-md-12">
									<div className="row">
										<div className="col-sm-12">
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Name</div>
												<div className="col-sm-7 offeringDetailSubTitle">{offeringInfo.name} ({offeringInfo.ticker_symbol})</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Status</div>
												<div className="col-sm-7 offeringDetailSubTitle">{offeringInfo.status}</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Type</div>
												<div className="col-sm-7 offeringDetailSubTitle">{offeringInfo.offering_type_name}</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Trade Date</div>
												<div className="col-sm-7 offeringDetailSubTitle">{(offeringInfo.trade_date)}</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Settlement Date</div>
												<div className="col-sm-7 offeringDetailSubTitle">{(offeringInfo.settlement_date)}</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Final Price  </div>
												<div className="col-sm-7 offeringDetailSubTitle"> $ {offeringInfo.final_price}</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Price  Range</div>
												<div className="col-sm-7 offeringDetailSubTitle">
												$ {offeringInfo.min_price} - $ {offeringInfo.max_price}
												</div>
											</div>
											<div className="row">
												<div className="col-sm-5 offeringDetailTitle">Description</div>
												<div className="col-sm-7 offeringDetailSubTitle">{offeringInfo.description}</div>
											</div>
										</div>
									</div>

								</div>
							</DialogContent>
						</Dialog>
					</div>
			</Dashboard>
		)
	}
}

OfferingComponent.propTypes = {
	offeringRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
	offeringRes: doOfferingRes,
});

function mapDispatchToProps(dispatch) {
	return {
		getOfferings: (data) => dispatch(get_offering(data)),
	};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(OfferingComponent);
